import { css } from "@emotion/css";
import { theme } from "assets/theme";
import { Input } from "components";
import React from "react";

type Props = {
  label: string;
  value?: string;
  placeholder: string;
  readOnly?: boolean;
  type?: "text" | "password" | "email";
  onChange: (value: string) => void;
};
export const FormItem: React.FC<Props> = ({
  label,
  placeholder,
  value,
  readOnly,
  type,
  onChange,
}) => {
  const id = `input-${label.toLowerCase().split(" ").join("-")}`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      `}
    >
      <label
        htmlFor={id}
        className={css`
          font-size: ${theme.font["body-2xs"].fontSize};
          color: ${theme.colors.text.seconday};
          margin-bottom: 4px;
        `}
      >
        {label}
      </label>
      <Input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        readOnly={readOnly}
        style={{ width: "100%" }}
      />
    </div>
  );
};
